import styled from "styled-components";

export const InputContainer = styled("div")`
  margin: 7px 5px 0 5px;
`;
